import platform from 'components/Trackers/platform'
import { useTracking } from 'utils/analytics/useTracking'

export const useCardSignatureTracking = () => {
  const track = useTracking(screenViewed)

  return {
    confirmTapped: () => track.buttonTapped(confirmTapped),
    clearTapped: () => track.buttonTapped(clearTapped),
  }
}

const sharedProps = {
  platform,
  card_type: 'moc',
  context: 'registration',
  screen: 'registrationSpendSignature',
  screen_name: 'registrationSpendSignature',
}

const screenViewed = {
  object: 'Screen',
  action: 'Viewed',
  object_name: 'registrationSpendSignature',
  ...sharedProps,
}

const confirmTapped = {
  object: 'Button',
  action: 'Tapped',
  object_name: 'registrationSpendSignatureConfirm',
  ...sharedProps,
}

const clearTapped = {
  object: 'Button',
  action: 'Tapped',
  object_name: 'registrationSpendSignatureClear',
  cta_title: 'clear',
  ...sharedProps,
}

export const usePhoneSignatureModalTracking = () => {
  const track = useTracking()

  return {
    containerViewed: () => track.containerViewed(phoneModalContainerViewed),
    sendTapped: () => track.buttonTapped(phoneModalSendTapped),
    cancelTapped: () => track.buttonTapped(phoneModalCancelTapped),
    sentContainerViewed: () => track.containerViewed(phoneModalSentContainerViewed),
    sentButtonTapped: () => track.buttonTapped(phoneModalSentConfirmTapped),
  }
}

const phoneModalContainerViewed = {
  object: 'Container',
  action: 'Viewed',
  object_name: 'registrationSignViaTextModal',
  ...sharedProps,
}

const phoneModalSendTapped = {
  object: 'Button',
  action: 'Tapped',
  object_name: 'registrationSignViaTextModalSendLink',
  ...sharedProps,
}

const phoneModalCancelTapped = {
  object: 'Button',
  action: 'Tapped',
  object_name: 'registrationSignViaTextModalCancel',
  ...sharedProps,
}

const phoneModalSentContainerViewed = {
  object: 'Container',
  action: 'Viewed',
  object_name: 'registrationOnItsWayModal',
  ...sharedProps,
}

const phoneModalSentConfirmTapped = {
  object: 'Button',
  action: 'Tapped',
  object_name: 'registrationOnItsWayModalOk',
  ...sharedProps,
}
